import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface ChatUnreadStore {
  officeUnread: boolean;
  tableUnread: boolean;
  setOfficeUnread: (unread: boolean) => void;
  setTableUnread: (unread: boolean) => void;
  clearUnread: () => void;
}

export const useChatUnreadStore = create<ChatUnreadStore>()(
  persist(
    (set) => ({
      clearUnread: () => set({ officeUnread: false, tableUnread: false }),
      officeUnread: false,
      setOfficeUnread: (unread: boolean) => set({ officeUnread: unread }),
      setTableUnread: (unread: boolean) => set({ tableUnread: unread }),
      tableUnread: false,
    }),
    {
      name: "bezoned-chat-unread",
      partialize: (state) => ({
        officeUnread: state.officeUnread,
        tableUnread: state.tableUnread,
      }),
      storage: createJSONStorage(() => localStorage),
    }
  )
);
